<template>
    <span>
        <v-button v-tip:info.hover type="link" kind="primary" icon="basic_papers_line" remote class="combos-btn">
            套餐信息
        </v-button>
        <v-tip ref="info" kind="large" placement="bottom-end" clazz="corpinfo-combos-tip">
            <v-descriptions>
                <v-description-item
                    text="账户到期时间"
                    :col="1"
                >
                    <div v-for="(item, index) in licenseInfo" :key="index">
                        <div :class="item.isExpired === 1 ? 'label-error' : ''">
                            <p v-if="item.isExpired !== 1" v-text="item.licenseName + ' ' + toDate(item.FExpireTime)" />
                            <p v-else v-text="item.licenseName + '已于' + toDate(item.FExpireTime) + '过期'" />
                            <p v-if="item.isExpired === 1">
                            请联系经销商续费
                            </p>
                        </div>
                    </div>
                </v-description-item>
            </v-descriptions>
            <v-descriptions>
                <v-description-item
                    v-if="customerLimit"
                    text="客户库容量"
                    :col="1"
                >
                    <div v-text="customerLimit.combos + ' ' + customerLimit.owner + '/' + customerLimit.limit" />
                    <v-progress style="width: 100%;" :value="process" :no-text="true" />
                </v-description-item>
            </v-descriptions>
            <v-descriptions>
                <v-description-item
                    v-if="qfSendAmount"
                    text="群发剩余配额"
                    :col="1"
                >
                    {{ qfSendAmount }}条
                </v-description-item>
            </v-descriptions>
        </v-tip>
    </span>
</template>

<script>
import { toDate }  from '@/utils/formatDate';
export default {
    props: {
        combosInfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            toDate,
        };
    },
    computed: {
        licenseInfo() {
            return this.combosInfo.licenseInfo;
        },
        customerLimit() {
            return this.combosInfo.customerLimit;
        },
        qfSendAmount() {
            return this.combosInfo.qfSendAmount;
        },
        process() {
            const process = Math.round(this.customerLimit.owner / this.customerLimit.limit * 100);
            return process > 100 ? 100 : process;
        },
    },
};
</script>

<style lang="less">
.label-error {
    color: rgba(247, 85, 89, 1);
}
.combos-btn {
    vertical-align: top;
}
.corpinfo-combos-tip {
    width: 500px;
}
</style>
